import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { ResponsiveTableModule } from '../../../../shared';
import { AssortmentTableComponent } from './assortment-table.component';

@NgModule({
  imports: [CommonModule, I18nModule, ResponsiveTableModule, NzIconModule, NgbTooltipModule],
  declarations: [AssortmentTableComponent],
  exports: [AssortmentTableComponent],
})
export class AssortmentTableModule {}
